import React, { useCallback } from 'react';

import { DownloadExtension } from '@candu-ai/content/create';
import { SnapshotState } from 'dashboard/pages/Content/pages/Create/pages/Snapshot';

interface Props {
  onSkip?: () => void;
  setCurrentState: (state: SnapshotState) => void;
}

export const Extension = ({ setCurrentState, onSkip }: Props) => {
  const onGoBack = useCallback(() => {
    setCurrentState('Location');
  }, [setCurrentState]);

  return <DownloadExtension onSkip={onSkip} onGoBack={onGoBack} />;
};
